<template>
  <Button
    type="text"
    class="llm-add-param-btn"
    :disabled="disabled"
    v-on="$listeners"
  >
    + 添加参数
  </Button>
</template>

<script>
export default {
  name: 'AddParamLinkButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.llm-add-param-btn {
  flex-shrink: 0;
  color: #5668f0 !important;
  padding: 2px 8px !important;
  height: auto !important;
  border-radius: 4px !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  transition: background 0.15s ease, color 0.15s ease;
}

.llm-add-param-btn:hover:not([disabled]):not(.ivu-btn-disabled),
.llm-add-param-btn:focus:not([disabled]):not(.ivu-btn-disabled),
.llm-add-param-btn.ivu-btn:hover:not(.ivu-btn-disabled),
.llm-add-param-btn.ivu-btn:focus:not(.ivu-btn-disabled) {
  color: #3f51e8 !important;
  background: #f5f7ff !important;
  border: none !important;
  box-shadow: none !important;
}

.llm-add-param-btn[disabled],
.llm-add-param-btn.ivu-btn-disabled {
  color: #c5c8ce !important;
  cursor: not-allowed !important;
  background: transparent !important;
}
</style>
